<div container [classes]="'container--1320'">
  <div
    class="navigation-bar d-flex justify-content-between align-items-center gap-lg-3"
  >
    @if (!isSpanish) {
      <a class="navigation-bar__logo d-block" [routerLink]="'/'">
        <img
          class="img-fluid"
          [src]="
            isWhiteNav && isMenuCollapsed
              ? '/assets/img/header/SFT1-logo-white.svg'
              : '/assets/img/header/SFT1-logo.svg'
          "
          alt="Screen for Type 1 logo"
          width="151"
          height="68"
        />
      </a>
    } @else {
      <a class="navigation-bar__logo--spanish d-block" [routerLink]="'/es'">
        <img
          class="img-fluid"
          [src]="
            isWhiteNav && isMenuCollapsed
              ? '/assets/img/header/SFT1-logo-white-spanish.svg'
              : '/assets/img/header/SFT1-logo-spanish.svg'
          "
          alt="Logotipo de Formulario de Selección Tipo 1"
          width="261"
          height="65"
        />
      </a>
    }
    <!-- hamburguer menu (only mob) -->
    <button
      class="navigation-bar__hamburguer d-flex d-lg-none flex-column gap-1"
      [class.navigation-bar__hamburguer--open]="!isMenuCollapsed"
      [attr.aria-expanded]="!isMenuCollapsed"
      (click)="toggleMenu(); menuState()"
    >
      <div
        class="line"
        [class.bg-dark]="!isWhiteNav || !isMenuCollapsed"
        [class.bg-white]="isWhiteNav && isMenuCollapsed"
      ></div>
      <div
        class="line"
        [class.bg-dark]="!isWhiteNav || !isMenuCollapsed"
        [class.bg-white]="isWhiteNav && isMenuCollapsed"
      ></div>
      <div
        class="line"
        [class.bg-dark]="!isWhiteNav || !isMenuCollapsed"
        [class.bg-white]="isWhiteNav && isMenuCollapsed"
      ></div>
    </button>
    <!-- menu desktop -->
    <div menu-desktop [isWhiteNav]="isWhiteNav" [isSpanish]="isSpanish"></div>
  </div>
</div>

<!-- menu mobile -->
<div
  menu-mobile
  [isMenuCollapsed]="isMenuCollapsed"
  (collapseMenu)="toggleMenu()"
  [isSpanish]="isSpanish"
></div>
